class TaxInvoiceClassItem {
    /**
     * @param {Object} data
     * @param {number} data.user_id
     * @param {string} data.name
     * @param {string} data.phone
     * @param {number} data.contract_id
     * @param {number|string} data.course_fee
     * @param {number|string} data.total
     * @param {string} data.course_name
     * @param {number|string} data.tong_gia_khoa
     * @param {number|string} data.tong_gia_tri_hop_dong
     * @param {string} data.ten_lop
     * @param {string} data.ten_chi_nhanh
     * @param {string} data.lich_hoc
     * @param {number|string} data.course_value
     * @param {number|string} data.doanh_thu_buoi_hoc
     * @param {string|null} data.ngay_bat_dau_lop
     * @param {string|null} data.ngay_ket_thuc_lop
     * @param {string|null} data.ngay_khai_giang_du_kien
     * @param {number|string} data.lesson
     * @param {string|null} data.date
     * @param {string|null} data.date_time
     * @param {string} data.lesson_string
     * @param {string} data.teacher_name
     */
    constructor(data = {}) {
        this.user_id = data.user_id ? Number(data.user_id) + 100000 : null;
        this.name = data.name ?? null;
        this.phone = data.phone ?? null;
        this.contract_id = data.contract_id ?? null;
        this.course_fee = data.course_fee != null ? Number(data.course_fee) : 0;
        this.course_name = data.course_name ?? null;
        this.total = data.total != null ? Number(data.total) : 0;
        this.tong_gia_khoa = data.tong_gia_khoa != null ? Number(data.tong_gia_khoa) : 0;
        this.tong_gia_tri_hop_dong = data.tong_gia_tri_hop_dong != null ? Number(data.tong_gia_tri_hop_dong) : 0;
        this.ten_lop = data.ten_lop ?? '';
        this.ten_chi_nhanh = data.ten_chi_nhanh ?? '';
        this.lich_hoc = data.lich_hoc ?? '';
        this.course_value = data.course_value != null ? Number(data.course_value) : 0;
        this.doanh_thu_buoi_hoc = data.doanh_thu_buoi_hoc != null ? Number(data.doanh_thu_buoi_hoc) : 0;
        this.ngay_bat_dau_lop = data.ngay_bat_dau_lop ?? null;
        this.ngay_ket_thuc_lop = data.ngay_ket_thuc_lop ?? null;
        this.ngay_khai_giang_du_kien = data.ngay_khai_giang_du_kien ?? null;
        this.lesson = data.lesson != null ? Number(data.lesson) : null;
        this.date = data.date ?? null;
        this.date_time = data.date_time ?? null;
        this.lesson_string = data.lesson_string ?? '';
        this.teacher_name = data.teacher_name ?? '';
    }

    static fromDB(row) {
        return new TaxInvoiceClassItem(row);
    }

    static fromDBList(rows = []) {
        return rows.map((row) => TaxInvoiceClassItem.fromDB(row));
    }

    toJSON() {
        return {
            user_id: this.user_id,
            name: this.name,
            phone: this.phone,
            contract_id: this.contract_id,
            course_fee: this.course_fee,
            total: this.total,
            course_name: this.course_name,
            tong_gia_khoa: this.tong_gia_khoa,
            tong_gia_tri_hop_dong: this.tong_gia_tri_hop_dong,
            ten_lop: this.ten_lop,
            ten_chi_nhanh: this.ten_chi_nhanh,
            lich_hoc: this.lich_hoc,
            course_value: this.course_value,
            doanh_thu_buoi_hoc: this.doanh_thu_buoi_hoc,
            ngay_bat_dau_lop: this.ngay_bat_dau_lop,
            ngay_ket_thuc_lop: this.ngay_ket_thuc_lop,
            ngay_khai_giang_du_kien: this.ngay_khai_giang_du_kien,
            lesson: this.lesson,
            date: this.date,
            date_time: this.date_time,
            lesson_string: this.lesson_string,
            teacher_name: this.teacher_name,
        };
    }

    toExcelRow() {
        return {
            user_id: this.user_id,
            name: this.name,
            phone: this.phone,
            contract_id: this.contract_id,
            course_fee: this.course_fee,
            total: this.total,
            course_name: this.course_name,
            tong_gia_khoa: this.tong_gia_khoa,
            tong_gia_tri_hop_dong: this.tong_gia_tri_hop_dong,
            ten_lop: this.ten_lop,
            ten_chi_nhanh: this.ten_chi_nhanh,
            lich_hoc: this.lich_hoc,
            course_value: this.course_value,
            doanh_thu_buoi_hoc: this.doanh_thu_buoi_hoc,
            ngay_bat_dau_lop: this.ngay_bat_dau_lop,
            ngay_ket_thuc_lop: this.ngay_ket_thuc_lop,
            ngay_khai_giang_du_kien: this.ngay_khai_giang_du_kien,
            lesson: this.lesson,
            date: this.date,
            date_time: this.date_time,
            lesson_string: this.lesson_string,
            teacher_name: this.teacher_name,
        };
    }
}

module.exports = TaxInvoiceClassItem;
